import { Types } from '@store/types';

const BlockReducer = (state = {}, action) => {
	switch (action.type) {
		case Types.SET_BLOCK_ACTION:
			return { ...state, currentBlockAction: action.payload };
		default:
			return state;
	}
};

export default BlockReducer;
